
import { Component, Prop, Vue } from 'vue-property-decorator';

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { agreeDisagreeInfoType, schedule1DataInfoType,schedule2DataInfoType } from '@/types/Application/ReplyFamilyLawMatter/Pdf';
import { replyExistingParentingArrangementsDataInfoType } from '@/types/Application/ReplyFamilyLawMatter/ParentingArrangements';
import { replyNewConditionsParentingTimeDataInfoType, replyNewParentalResponsibilitiesDataInfoType, replyNewParentingTimeDataInfoType } from '@/types/Application/ReplyFamilyLawMatter/ParentingArrangements';
import ScheduleHeader from '@/components/utils/PopulateForms/components/ScheduleHeader.vue';
import NoteBox from '@/components/utils/PopulateForms/components/NoteBox.vue';
import FormPart from '@/components/utils/PopulateForms/components/FormPart.vue';
import GreyBoxForm from '@/components/utils/PopulateForms/components/GreyBoxForm.vue';

@Component({
    components:{
        UnderlineForm,
        CheckBox,
        ScheduleHeader,
        NoteBox,
        FormPart,
        GreyBoxForm
    }
})

export default class Schedule1 extends Vue {

    @Prop({required:true})
    result!: any;

    @Prop({required:true})
    agreeDisagreeResults!: agreeDisagreeInfoType;

    dataReady = false;
    parentArrInfo = {} as schedule1DataInfoType;  
    exParentArrInfo = {} as schedule2DataInfoType;  
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;
    } 

    public extractInfo(){ 
        this.parentArrInfo = this.getParentingArrangementsInfo();
        this.exParentArrInfo = this.getExistingParentingArrangementsInfo();
    } 

    public getParentingArrangementsInfo(){
        let parentingArrangements = {} as schedule1DataInfoType;       

        if (this.agreeDisagreeResults.newParentResp.opApplied && !this.agreeDisagreeResults.newParentResp.agree){
            const parentingResp: replyNewParentalResponsibilitiesDataInfoType = this.result.replyNewParentalResponsibilitiesSurvey
            parentingArrangements.parentResp = {
                applying: true,
                disagreeExpl: parentingResp.disagreeReason,
                askExpl: parentingResp.requestedParentalResponsibilities,
                bestInterestExpl: parentingResp.childBestInterestReason                
            }

        } else {
            parentingArrangements.parentResp= {
                applying: false,
                disagreeExpl: '',
                askExpl: '',
                bestInterestExpl: '' 
            }
        }

        if (this.agreeDisagreeResults.newParentTime.opApplied && !this.agreeDisagreeResults.newParentTime.agree){
            const parentingTime: replyNewParentingTimeDataInfoType = this.result.replyNewParentingTimeSurvey
            parentingArrangements.parentTime = {
                applying: true,
                disagreeExpl: parentingTime.disagreeReason,
                askExpl: parentingTime.requestedParentalTime,
                bestInterestExpl: parentingTime.childBestInterestReason 
            }

        } else {
            parentingArrangements.parentTime = {
                applying: false,
                disagreeExpl: '',
                askExpl: '',
                bestInterestExpl: ''   
            }     
        }

        if (this.agreeDisagreeResults.newParentTimeConditions.opApplied && !this.agreeDisagreeResults.newParentTimeConditions.agree){
            const parentingTimeConditions: replyNewConditionsParentingTimeDataInfoType = this.result.replyNewConditionsParentingTimeSurvey
            parentingArrangements.parentTimeConditions = {
                applying: true,
                disagreeExpl: parentingTimeConditions.disagreeReason,
                askExpl: parentingTimeConditions.requestedConditionParentalTime,
                bestInterestExpl: parentingTimeConditions.childBestInterestReason                 
            }
        } else {
            parentingArrangements.parentTimeConditions = {
                applying: false,
                disagreeExpl: '',
                askExpl: '',
                bestInterestExpl: ''                
            }
        }       
        
        return parentingArrangements;
    }

    public getExistingParentingArrangementsInfo(){
        let existingParentingArrangements = {} as schedule2DataInfoType; 

        if(this.result.replyExistingParentingArrangementsSurvey){

            const existingInfo: replyExistingParentingArrangementsDataInfoType = this.result.replyExistingParentingArrangementsSurvey;

            const disagreeItem = (this.agreeDisagreeResults.existingParentResp.opApplied && !this.agreeDisagreeResults.existingParentResp.agree)
                || (this.agreeDisagreeResults.existingParentTime.opApplied && !this.agreeDisagreeResults.existingParentTime.agree)
                || (this.agreeDisagreeResults.existingParentTimeConditions.opApplied && !this.agreeDisagreeResults.existingParentTimeConditions.agree);

                console.log(this.agreeDisagreeResults)

            if (disagreeItem){
                if (existingInfo.existingType == 'finalOrder'){
                    existingParentingArrangements.existingType = 'finalOrder';
                    existingParentingArrangements.agreeNeedsChanges = existingInfo.agreeFinalOrder == 'y';
                    existingParentingArrangements.agreeBestInterest = false;                
                } else if (existingInfo.existingType == 'agreement'){
                    existingParentingArrangements.existingType = 'agreement';
                    existingParentingArrangements.agreeBestInterest = existingInfo.agreeAgreement == 'y';
                    existingParentingArrangements.agreeNeedsChanges = false;
                }                
                existingParentingArrangements.disagreeExpl = existingInfo.disagreeReason?existingInfo.disagreeReason:''
                existingParentingArrangements.noChange = existingInfo.desiredOrderChoice == 'noChange';
                existingParentingArrangements.change = existingInfo.desiredOrderChoice == 'differentChange';
                const changeExplanationRequired = (existingInfo.desiredOrderChoice == 'differentChange') && existingInfo.requestedParentingArrangements
                existingParentingArrangements.changeExpl = changeExplanationRequired?existingInfo.requestedParentingArrangements:'';
                existingParentingArrangements.bestInterestExpl = existingInfo.childBestInterestReason?existingInfo.childBestInterestReason:'';

            } else {
                existingInfo.existingType = '';
                existingParentingArrangements.agreeBestInterest = false;
                existingParentingArrangements.agreeNeedsChanges = false;
                existingParentingArrangements.disagreeExpl = '';
                existingParentingArrangements.noChange = false;
                existingParentingArrangements.change = false;
                existingParentingArrangements.changeExpl = ''
                existingParentingArrangements.bestInterestExpl = '';
            }              
        } 
        
        return existingParentingArrangements;
    }
}
